import { customDictionary } from '@/plugin/vee-validation/dictionary';

export const dictionary = {
    i18nRootKey: 'validations',
    dictionary: customDictionary,
    inject: true,
    fieldsBagName: "veeFields",
    errorBagName: "veeErrors"
}